<template>
  <div class="about">
    <h1 style="mb-5">A propos</h1>
    <v-row>
      <v-col md=6 xs=12 sm=12>
        <v-card>
          <v-card-title>
            <h2>Mode d'emploi</h2>
            <v-spacer></v-spacer>
            <v-btn
              class="mb-3 mr-3"
              color="secondary"
              href="CineStaff_manuel.pdf"
              target="_blank"
            >
              <v-icon left>  
                mdi-file-pdf-box
              </v-icon>
              Télécharger en PDF
            </v-btn>
          </v-card-title>
          <v-card-text>
            <vue-pdf-embed source="CineStaff_manuel.pdf" />
          </v-card-text>
        </v-card>
      </v-col>
    <v-col md=6 xs=12 sm=12>
      <v-card>
          <v-card-title>
            <h2>Signalement de problèmes</h2>
          </v-card-title>
          <v-card-text>
            <p>Cinestaff est encore en développement, si vous rencontrez un problème ou un bug n'hésitez pas à le signaler à cette adresse: <a href="mailto:vincent.audergon@bluewin.ch">vincent.audergon@bluewin.ch</a>. Merci!</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
export default {
  components: {
    VuePdfEmbed,
  },
  data() {
    return {
    };
  },
};
</script>
